module.exports = __webpack_public_path__ + "img/189.978dda87.jpg";